import React, { Component } from 'react';
import moment from 'moment';
import $ from "jquery";
import { ApiClient } from "../libs/apiClient";
import { SERVICE_RESPONSE } from '../libs/utils/Const';

let apiClient = ApiClient.getInstance();

class AddressesPorteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            states: [],
            municipios: [],
            localidades: [],
            colonias: [],
            isSearchCodigoPostal: false,
        };
    }
    componentDidMount = () => {
        this._handelBack();
        this.closeAction();
    }
    closeAction = () => {
        const { cleanData } = this.props;
        $('#AddressesPorteModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    }

    restartTabs = () => {
        $('#nav-address-tab1').removeClass('active');
        $('#nav-address-tab2').removeClass('active');

        $('#nav-address-tab1').removeClass('nav-link-current');
        $('#nav-address-tab2').removeClass('nav-link-current');

        $('#Section1').removeClass('active');
        $('#Section2').removeClass('active');

        $('#Section1').removeClass('show');
        $('#Section2').removeClass('show');

        $('#nav-address-tab1').addClass('active');
        $('#Section1').addClass('active');
        $('#Section1').addClass('show');
    };

    closeModal = () => {
        $('#AddressesPorteModal').modal('hide');
        this.restartTabs();
        this.setState({ isSearchCodigoPostal: false });
    }

    /*/ OPTIMIZAR CONSULTA
    getCodigoPostalSAT = async (codigoPostal) => {
        const { showAlert, enableSpinner, addressModel } = this.props;
        if (!codigoPostal) {
            showAlert({ type: 'info', message: 'No hay un Codigo postal' });
            return;
        }
        this.setState({
            isSearchCodigoPostal: true,
        });
        enableSpinner(true);
        let codigoPostalSATResponse = await apiClient.getCodigoPostalSAT(codigoPostal);
        enableSpinner(false);
        if (codigoPostalSATResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        if (codigoPostalSATResponse.status === SERVICE_RESPONSE.SUCCESS) {
            addressModel.Pais = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Pais : '';
            addressModel.Estado = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Estado : '';
            addressModel.Municipio = codigoPostalSATResponse.data.direccion[0] ? codigoPostalSATResponse.data.direccion[0].c_Municipio : '';
            this.refreshModel(addressModel);
            this.setState({
                localidades: codigoPostalSATResponse.data.localidades,
                colonias: codigoPostalSATResponse.data.colonias,
                municipios: codigoPostalSATResponse.data.municipios,
            });
        }
    }*/

    //#region FieldModel
    changeFieldModel = async (model, key, event, byTab = false) => {
        const { getAddressDetailSAT } = this.props;
        model[key] = event.nativeEvent.target.value;
        getAddressDetailSAT(key, event.nativeEvent.target.value, model, byTab);
    };
    //#endregion


    //#region Render

    renderAddressHeader = () => {
        const { model, addressModel, action, editMode } = this.props;
        return (
            <div className="row">
                {/*PRIMER COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*TipoUbicacion CARTA PORTE*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">TipoUbicacion</span>
                        </div>
                        <select className="form-control"
                            onChange={(event) => this.changeFieldModel(addressModel, 'TipoUbicacion', event)}
                            value={addressModel.TipoUbicacion ? addressModel.TipoUbicacion : ""}
                        >
                            <option value=''>Seleccione una opción</option>
                            <option value='Origen'>Origen</option>
                            <option value='Destino'>Destino</option>
                        </select>
                    </div>

                    {/*RFCRemitenteDestinatario CARTA PORTE*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">RUT Remitente/Destinatario</span>
                        </div>
                        <input type="text" className="form-control"
                            onChange={(event) => this.changeFieldModel(addressModel, 'RFCRemitenteDestinatario', event)}
                            disabled={(action === 2 && !editMode) || model.TypeDoc !== 'I'}
                            maxLength={13}
                            value={addressModel.RFCRemitenteDestinatario ? addressModel.RFCRemitenteDestinatario : ""}
                        />
                    </div>

                </div>

                {/*SEGUNDA COLUMNA*/}
                <div className="col-12 col-md-6">
                    {/*IDUbicacion CARTA PORTE*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">IDUbicacion</span>
                        </div>
                        <input type="text" className="form-control"
                            onChange={(event) => this.changeFieldModel(addressModel, 'IDUbicacion', event)}
                            disabled={(action == 2 && !editMode) ? true : false}
                            value={addressModel.IDUbicacion ? addressModel.IDUbicacion : ""}
                        />
                    </div>

                    {/*NombreRemitenteDestinatario CARTA PORTE*/}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">NombreRemitenteDestinatario</span>
                        </div>
                        <input type="text" className="form-control"
                            onChange={(event) => this.changeFieldModel(addressModel, 'NombreRemitenteDestinatario', event)}
                            disabled={(action === 2 && !editMode) || model.TypeDoc !== 'I'}
                            value={addressModel.NombreRemitenteDestinatario ? addressModel.NombreRemitenteDestinatario : ""}
                        />
                    </div>
                </div>

                <br></br>
            </div>
        )
    }

    renderAddressBody = () => {
        const { addressModel, countries, action, editMode, flagAddressesPorteModal, states, municipios, localidades, colonias, openAddresses, getAddressesSAT } = this.props;
        const { isSearchCodigoPostal } = this.state;
        return (
            <div style={{ marginTop: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary active"
                            id="nav-address-tab1"
                            data-toggle="tab"
                            href="#Section1"
                            role="role1"
                            aria-controls="Section1"
                            aria-selected="true">
                            Datos Generales
                        </a>
                        <a
                            className="nav-item nav-link font-weight-bold text-secondary "
                            id="nav-address-tab2"
                            data-toggle="tab"
                            href="#Section2"
                            role="role2"
                            aria-controls="Section2"
                            aria-selected="false"
                            onClick={() => this.changeFieldModel(addressModel, 'Municipio', { nativeEvent: { target: { value: addressModel.Municipio } } }, true)}>
                            Domicilio
                        </a>
                    </div>
                </nav>
                <div className="tab-content" style={{ textAlign: 'left' }}>
                    {/* SUB-APARTADO DatosGenerales */}
                    <div className="container tab-pane active"
                        id="Section1"
                        role="role1"
                        aria-labelledby="nav-address-tab1"
                    >
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6"><br></br>

                                {/*NumRegIdTrib CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumRegIdTrib</span>
                                    </div>
                                    <input
                                        type="number"
                                        className="form-control"
                                        min={0}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onChange={(event) => this.changeFieldModel(addressModel, 'NumRegIdTrib', event)}
                                        value={addressModel.NumRegIdTrib ? addressModel.NumRegIdTrib : ""}
                                    />
                                </div>
                                {/*FechaHoraSalidaLlegada CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">FechaHoraSalidaLlegada</span>
                                    </div>
                                    <input type="datetime-local" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'FechaHoraSalidaLlegada', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.FechaHoraSalidaLlegada ? addressModel.FechaHoraSalidaLlegada : ""}
                                    />
                                </div>
                                {/*TipoEstacion CARTA PORTE*/}
                                {/* <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text font-weight-bold" id="basic-addon1">TipoEstacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'TipoEstacion', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.TipoEstacion ? addressModel.TipoEstacion : ""}
                                    />
                                </div> */}
                                {/*NombreEstacion CARTA PORTE*/}
                                {/* <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text font-weight-bold" id="basic-addon1">NombreEstacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'NombreEstacion', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.NombreEstacion ? addressModel.NombreEstacion : ""}
                                    />
                                </div> */}

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                {/*ResidenciaFiscal CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">ResidenciaFiscal</span>
                                    </div>
                                    <select className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'ResidenciaFiscal', event)}
                                        value={addressModel.ResidenciaFiscal ? addressModel.ResidenciaFiscal : ""}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        {!!countries && countries.map((dato => {
                                            return (<option value={dato.c_Pais}>{dato.Nombre}</option>);
                                        }))}
                                    </select>
                                </div>
                                {/*DistanciaRecorrida CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">DistanciaRecorrida</span>
                                    </div>
                                    <input type="number" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'DistanciaRecorrida', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.DistanciaRecorrida ? addressModel.DistanciaRecorrida : 0}
                                    />
                                </div>

                                {/*NumEstacion CARTA PORTE*/}
                                {/* <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text font-weight-bold" id="basic-addon1">NumEstacion</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'NumEstacion', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.NumEstacion ? addressModel.NumEstacion : ""}
                                    />
                                </div> */}
                                {/*NavegacionTrafico CARTA PORTE*/}
                                {/* <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text font-weight-bold" id="basic-addon1">NavegacionTrafico</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'NavegacionTrafico', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.NavegacionTrafico ? addressModel.NavegacionTrafico : ""}
                                    />
                                </div> */}

                            </div>
                        </div>
                    </div>

                    {/* SUB-APARTADO Section-2 */}
                    <div className="container tab-pane fade"
                        id="Section2"
                        role="role2"
                        aria-labelledby="nav-address-tab2"
                    >
                        <div className="row col-sm col" style={{ paddingRight: 0 }}>
                            {/*Primera columna*/}
                            <div className="col-12 col-md-6"><br></br>
                                {/*Calle CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Calle</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'Calle', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        maxLength={5000}
                                        value={addressModel.Calle ? addressModel.Calle : ""}
                                    />
                                    <button
                                        type="button"
                                        style={(action == 2 && !editMode) ? { color: '#EABF28' } : { backgroundColor: 'transparent', color: '#EABF28' }}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        className="input-group-text"
                                        onClick={openAddresses}>
                                        <i className="fa fa-list" aria-hidden="true" />
                                    </button>
                                </div>
                                {/*NumeroExterior CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumeroExterior</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'NumeroExterior', event)}
                                        maxLength={10}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.NumeroExterior ? addressModel.NumeroExterior : ""}
                                    />
                                </div>

                                {/*CodigoPostal CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Código Postal</span>
                                    </div>
                                    <input type="number" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'CodigoPostal', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.CodigoPostal ? addressModel.CodigoPostal : ""}
                                        maxLength={5}
                                        onKeyPress={(eve) => {
                                            if (eve.key === 'Enter') {
                                                getAddressesSAT(addressModel, addressModel.CodigoPostal ? addressModel.CodigoPostal : "");
                                            }
                                        }}
                                    />
                                    <button type="button" className="input-group-text"
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        onClick={() => { getAddressesSAT(addressModel, addressModel.CodigoPostal ? addressModel.CodigoPostal : "") }}>
                                        <i className="fas fa-search-location fa-lg" />
                                    </button>
                                </div>
                                {/*Estado CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Estado</span>
                                    </div>
                                    {(addressModel && addressModel.Pais && addressModel.Pais !== 'MEX') ?
                                        <input type="text" className="form-control"
                                            disabled={(action === 2 && !editMode) ? true : false}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Estado', event)}
                                            value={addressModel.Estado ? addressModel.Estado : ""}
                                        />
                                        :
                                        <select className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? !(addressModel && addressModel.Pais === 'MEX') : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Estado', event)}
                                            value={addressModel.Estado ? addressModel.Estado : ""}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {!!states && states.map((dato => {
                                                return (<option value={dato.c_Estado}>{dato.Estado}</option>);
                                            }))}
                                        </select>
                                    }
                                </div>
                                {/*Localidad CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Localidad</span>
                                    </div>
                                    {addressModel && addressModel.Pais !== '' && addressModel.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? false : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Localidad', event)}
                                            value={addressModel.Localidad ? addressModel.Localidad : ""}
                                        />
                                        :
                                        <select className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? !(localidades && localidades.length > 0) : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Localidad', event)}
                                            value={addressModel.Localidad ? addressModel.Localidad : ""}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {(localidades && localidades.length > 0) &&
                                                localidades?.map(dato => { return (<option value={dato.c_Localidad}>{dato.Localidad}</option>); })
                                            }
                                        </select>
                                    }
                                </div>

                            </div>

                            {/*Segunda columna*/}
                            <div className="col-sm" style={{ paddingRight: 0 }}><br></br>

                                {/*Referencia CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'Referencia', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        maxLength={5000}
                                        value={addressModel.Referencia ? addressModel.Referencia : ""}
                                    />
                                </div>
                                {/*NumeroInterior CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">NumeroInterior</span>
                                    </div>
                                    <input type="text" className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'NumeroInterior', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        maxLength={10}
                                        value={addressModel.NumeroInterior ? addressModel.NumeroInterior : ""}
                                    />
                                </div>

                                {/*Pais CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Pais</span>
                                    </div>
                                    <select className="form-control"
                                        onChange={(event) => this.changeFieldModel(addressModel, 'Pais', event)}
                                        disabled={(action == 2 && !editMode) ? true : false}
                                        value={addressModel.Pais ? addressModel.Pais : ""}
                                    >
                                        <option value=''>Seleccione una opción</option>
                                        {!!countries && countries.map((dato => {
                                            return (<option value={dato.c_Pais}>{dato.Nombre}</option>);
                                        }))}
                                    </select>
                                </div>

                                {/*Municipio CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Municipio</span>
                                    </div>
                                    {addressModel && addressModel.Pais !== '' && addressModel.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? false : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Municipio', event)}
                                            value={addressModel.Municipio ? addressModel.Municipio : ""}
                                        />
                                        :
                                        <select className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? !(municipios && municipios.length > 0) : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Municipio', event)}
                                            value={addressModel.Municipio ? addressModel.Municipio : ""}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {municipios && municipios.map((dato => {
                                                return (<option value={dato.c_Municipio}>{dato.Municipio}</option>);
                                            }))}
                                        </select>
                                    }
                                </div>

                                {/*Colonia CARTA PORTE*/}
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Colonia</span>
                                    </div>
                                    {addressModel && addressModel.Pais !== '' && addressModel.Pais !== 'MEX' ?
                                        <input type="text" className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? false : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Colonia', event)}
                                            value={addressModel.Colonia ? addressModel.Colonia : ""}
                                        />
                                        :
                                        <select className="form-control"
                                            disabled={flagAddressesPorteModal && (action === 1 || action === 2) ? !(colonias && colonias.length > 0) : !isSearchCodigoPostal}
                                            onChange={(event) => this.changeFieldModel(addressModel, 'Colonia', event)}
                                            value={addressModel.Colonia ? addressModel.Colonia : ""}
                                        >
                                            <option value=''>Seleccione una opción</option>
                                            {colonias && colonias.map((dato => {
                                                return (<option value={dato.c_Colonia}>{dato.Colonias}</option>);
                                            }))}
                                        </select>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="modal fade bd-example-modal-xl modal-open scroll"
                id="AddressesPorteModal"
                role="dialog"
                aria-labelledby="exampleModalCenterTitle"
                aria-hidden="true">

                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">

                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">DATOS DE LA UBICACIÓN</h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                {this.renderAddressHeader()}
                                                {this.renderAddressBody()}
                                                <br></br><br></br>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.closeModal}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    //#endregion
}

export default AddressesPorteModal;